export const PRICING_VERSION = '2026-05-04-v1';

export const PRICING = {
  stone: {
    natural: {
      RO: { 1: 975, 2: 2125, 3: 2950, 4: 4550, 5: 5950 },
      OTHER: { 1: 845, 2: 1875, 3: 2580, 4: 4125, 5: 5855 },
    },
    lab: {
      RO: { 1: 360, 2: 530, 3: 825, 4: 975, 5: 1080 },
      OTHER: { 1: 325, 2: 485, 3: 755, 4: 885, 5: 975 },
    },
  },
  setting: {
    'AH-NO': { 1: 38, 2: 57, 3: 77, 4: 99, 5: 125 },
    'AY-NO': { 1: 38, 2: 57, 3: 77, 4: 99, 5: 125 },
    'AY-ST': { 1: 38, 2: 57, 3: 77, 4: 99, 5: 125 },
    'AY-HL': { 1: 38, 2: 57, 3: 77, 4: 99, 5: 125 },
    'AK-NO': { 1: 38, 2: 57, 3: 77, 4: 99, 5: 125 },
    'AK-ST': { 1: 38, 2: 57, 3: 77, 4: 99, 5: 125 },
    'SY-NO': { 1: 38, 2: 57, 3: 77, 4: 99, 5: 125 },
    'SY-ST': { 1: 38, 2: 57, 3: 77, 4: 99, 5: 125 },
    'SY-HL': { 1: 38, 2: 57, 3: 77, 4: 99, 5: 125 },
    'SK-NO': { 1: 38, 2: 57, 3: 77, 4: 99, 5: 125 },
    'SK-ST': { 1: 38, 2: 57, 3: 77, 4: 99, 5: 125 },
    'SH-NO': { 1: 38, 2: 57, 3: 77, 4: 99, 5: 125 },
  },
  band: {
    1: 48,
    2: 108,
    3: 43,
    4: 46,
  },
  metalType: {
    gold18k: 375,
    gold14k: 285,
    gold8k: 175,
    silver: 54,
  },
  metalColorDiff: {
    YellowGold: 0,
    WhiteGold: 0,
    RoseGold: 0,
  },
};

export const STONE_TYPES = ['RO', 'EM', 'OV', 'MR', 'PR', 'PE'];
export const STONE_SIZES = ['1', '2', '3', '4', '5'];
export const STONE_ORIGINS = ['natural', 'lab'];
export const BAND_TYPES = ['1', '2', '3', '4'];
export const METAL_TYPES = Object.keys(PRICING.metalType);
export const ROUND_OVAL_SETTINGS = ['AH-NO', 'AY-NO', 'AY-ST', 'AY-HL', 'AK-NO', 'AK-ST'];
export const OTHER_SETTINGS = ['SY-NO', 'SY-ST', 'SY-HL', 'SK-NO', 'SK-ST'];
export const COMMON_SETTINGS = ['SH-NO'];

export function getSettingTypesForStone(stoneType) {
  const base = stoneType === 'RO' || stoneType === 'OV'
    ? ROUND_OVAL_SETTINGS
    : OTHER_SETTINGS;
  return [...base, ...COMMON_SETTINGS];
}

export function calculatePrice(stoneType, stoneSize, yuvaType, bandType, metalType, stoneOrigin) {
  const stoneGroup = stoneType === 'RO' ? 'RO' : 'OTHER';
  const stonePrice = PRICING.stone[stoneOrigin]?.[stoneGroup]?.[stoneSize] || 0;
  const settingPrice = PRICING.setting[yuvaType]?.[stoneSize] || 0;
  const bandPrice = PRICING.band[bandType] || 0;
  const metalTypePrice = PRICING.metalType[metalType] || 0;

  return Math.round((stonePrice + settingPrice + bandPrice + metalTypePrice) * 100) / 100;
}

function getAllConfiguredPrices() {
  const prices = [];

  STONE_TYPES.forEach((stoneType) => {
    STONE_SIZES.forEach((stoneSize) => {
      STONE_ORIGINS.forEach((stoneOrigin) => {
        BAND_TYPES.forEach((bandType) => {
          METAL_TYPES.forEach((metalType) => {
            getSettingTypesForStone(stoneType).forEach((yuvaType) => {
              prices.push(calculatePrice(stoneType, stoneSize, yuvaType, bandType, metalType, stoneOrigin));
            });
          });
        });
      });
    });
  });

  return prices;
}

const allConfiguredPrices = getAllConfiguredPrices();
const uniqueConfiguredPrices = Array.from(new Set(allConfiguredPrices)).sort((a, b) => a - b);

export const PRICE_RANGE = {
  combinations: allConfiguredPrices.length,
  uniquePrices: uniqueConfiguredPrices.length,
  min: uniqueConfiguredPrices[0],
  max: uniqueConfiguredPrices[uniqueConfiguredPrices.length - 1],
};

export const SHOPIFY_BASE_PRICE = PRICE_RANGE.max;
